/* ================================================================
   AISTROWISE — selección de unidades para la calculadora de sinastría
   Pure client-side: maps the /synastry-basic response to keys of the
   static astrologer-validated library. NO runtime AI. Analytics never
   see these keys (privacy contract).
   Assumes resp.aspects arrives sorted by strength desc from the API.
   Spec: aistrowise-claude/docs/specs/2026-07-23-calculadora-sinastria-design.md
   ================================================================ */
(function (global) {
  'use strict';

  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  }
  function slug(s) { return norm(s).replace(/\s+/g, '_'); }
  // A house number as this language writes it in a Klaviyo property: «7» in Spanish (aw-glosa.js),
  // «7th» in English (aw-glosa-en.js), so an English email can say «your 7th house» (plan inglés 4.x, 2026-10-21).
  function houseProp(n) { var g = typeof window !== 'undefined' && window.AWGlosa; return g && typeof g.ord === 'function' ? g.ord(n) : String(n); }
  // Valores para Klaviyo en el idioma de la página (revisión de código 2026-10-21): en español, el mismo texto.
  var T = function (s) { return typeof global.awT === 'function' ? global.awT(s) : s; };

  var ELEMENT = {
    aries: 'fuego', leo: 'fuego', sagitario: 'fuego',
    tauro: 'tierra', virgo: 'tierra', capricornio: 'tierra',
    geminis: 'aire', libra: 'aire', acuario: 'aire',
    cancer: 'agua', escorpio: 'agua', piscis: 'agua'
  };

  /* familia of a planet pair, for archetype + diversity rules + the locked
     door's report-section mapping. Precedence mirrors the paid engine
     (ROMANTIC_CATEGORY_MAP): Mercurio wins first (any Mercurio contact is
     communication — in Sol-Mercurio the function at play is Mercurio, the
     Sol only says whose), then Saturno, then the Luna-Venus exception
     (emotional warmth, not chemistry), then Venus/Marte, Luna, Sol. */
  function familia(a) {
    var p = [norm(a.p1_es), norm(a.p2_es)];
    if (p.indexOf('mercurio') > -1) return 'palabra';
    if (p.indexOf('saturno') > -1) return 'estructura';
    if (p.indexOf('luna') > -1 && p.indexOf('venus') > -1) return 'emocional';
    if (p.indexOf('venus') > -1 || p.indexOf('marte') > -1) return 'quimica';
    if (p.indexOf('luna') > -1) return 'emocional';
    if (p.indexOf('sol') > -1) return 'identidad';
    return 'energia';
  }

  function archetypeKey(resp) {
    var top = (resp.aspects || [])[0];
    if (!top) return 'arq_energia_armonico';
    return 'arq_' + familia(top) + '_' + slug(top.polarity);
  }

  function aspectKey(a) {
    var pair = [slug(a.p1_es), slug(a.p2_es)].sort();
    return pair[0] + '_' + pair[1] + '_' + slug(a.type_es);
  }

  function elemPairKey(prefix, signA, signB) {
    var pair = [ELEMENT[norm(signA)], ELEMENT[norm(signB)]].sort();
    return prefix + '_elem_' + pair[0] + '_' + pair[1];
  }

  /* top 2 aspects with library entries, distinct familias; element-pair
     guarantee keys fill any gap (luna first, then sol). */
  function pickReadable(resp, hasEntry) {
    var chosen = [], fams = {};
    var aspects = resp.aspects || [];
    for (var i = 0; i < aspects.length && chosen.length < 2; i++) {
      var a = aspects[i], k = aspectKey(a), f = familia(a);
      if (!hasEntry(k) || fams[f]) continue;
      fams[f] = true;
      chosen.push({ key: k, kind: 'aspect', aspect: a });
    }
    if (chosen.length < 2) {
      var pa = resp.person_a || {}, pb = resp.person_b || {};
      var guarantees = [];
      if (pa.luna && pb.luna && ELEMENT[norm(pa.luna.sign_es)] && ELEMENT[norm(pb.luna.sign_es)]) guarantees.push({ key: elemPairKey('luna', pa.luna.sign_es, pb.luna.sign_es), kind: 'elem', which: 'luna' });
      if (pa.sol && pb.sol && ELEMENT[norm(pa.sol.sign_es)] && ELEMENT[norm(pb.sol.sign_es)]) guarantees.push({ key: elemPairKey('sol', pa.sol.sign_es, pb.sol.sign_es), kind: 'elem', which: 'sol' });
      for (var g = 0; g < guarantees.length && chosen.length < 2; g++) {
        if (hasEntry(guarantees[g].key)) chosen.push(guarantees[g]);
      }
    }
    return harmonicFirst(chosen, aspects, hasEntry);
  }

  function pol(u) { return u && u.kind === 'aspect' && u.aspect ? u.aspect.polarity : ''; }

  /* R4 (spec 2026-08-20, risk-regulation evidence): the free result never
     OPENS with a tense unit. [tenso, no-tenso] -> swap order; both tenso ->
     replace the weaker one with the strongest deeper armonico that has an
     entry and a distinct familia, and lead with it (the displaced tense
     aspect then lands in the locked picks, where tension belongs). No
     armonico available -> unchanged. */
  function harmonicFirst(chosen, aspects, hasEntry) {
    if (chosen.length < 2 || pol(chosen[0]) !== 'tenso') return chosen;
    if (pol(chosen[1]) !== 'tenso') return [chosen[1], chosen[0]];
    var keepFam = familia(chosen[0].aspect);
    for (var i = 0; i < aspects.length; i++) {
      var a = aspects[i];
      if (a.polarity !== 'armonico') continue;
      var k = aspectKey(a);
      if (!hasEntry(k) || familia(a) === keepFam) continue;
      return [{ key: k, kind: 'aspect', aspect: a }, chosen[0]];
    }
    return chosen;
  }

  /* familia → the section of the paid informe that reads it in full. Every
     name here is a chapter of the paid report;
     the locked-unit door line must never name a section that does not exist. */
  var SECTION = {
    quimica: 'Atracción y química',
    emocional: 'Lo que necesita cada persona',
    palabra: 'Las conversaciones',
    estructura: 'Lo que sostiene la relación',
    identidad: 'Lo que hay entre tu pareja y tú',
    energia: 'Lo que hay entre tu pareja y tú'
  };
  function lockSection(a) { return SECTION[familia(a)] || SECTION.energia; }

  /* library-v2 fallback hook keys for locked units: overlay locks tease by
     casa terrain (planet-agnostic), entry-less aspect locks by familia +
     polaridad. The renderer tries entries[u.key].titular first. */
  function lockHookKey(u) {
    if (!u) return '';
    if (u.kind === 'overlay') return u.house >= 1 && u.house <= 12 ? 'lock_casa_' + u.house : '';
    if (u.kind === 'aspect' && u.aspect) return 'lock_fam_' + familia(u.aspect) + '_' + slug(u.aspect.polarity);
    return '';
  }

  /* locked anchors: 1 overlay teaser (paid territory) + unused aspects with
     tense ones first (spec 2026-08-20: negativity pulls hardest through a
     door), strength order preserved within each class. */
  function pickLocked(resp, usedKeys) {
    var locked = [];
    var ov = (resp.overlays_teaser || [])[0];
    if (ov) locked.push({ kind: 'overlay', planet_es: ov.planet_es, owner: ov.owner, house: ov.house });
    var aspects = resp.aspects || [];
    var tense = [], soft = [];
    for (var i = 0; i < aspects.length; i++) {
      var k = aspectKey(aspects[i]);
      if (usedKeys.indexOf(k) > -1) continue;
      (aspects[i].polarity === 'tenso' ? tense : soft).push({ kind: 'aspect', key: k, aspect: aspects[i] });
    }
    var ordered = tense.concat(soft);
    for (var j = 0; j < ordered.length && locked.length < 2; j++) locked.push(ordered[j]);
    return locked;
  }

  /* Serie de email L4 (2026-09-21): lo que el resultado pintó, para el perfil de Klaviyo.
     Misma selección que el render (pickReadable, pickLocked recortado a las legibles y el
     gancho con la regla N1 de un solo motivo). Solo puntuaciones, copia de la librería y
     signos: nunca nombres, fechas, horas ni lugares, ni el ancla del candado (lleva nombres). */
  var AREAS = [['atraccion', 'Atracción'], ['conexion_emocional', 'Conexión emocional'],
    ['comunicacion', 'Comunicación'], ['estabilidad', 'Estabilidad'], ['quimica', 'Química']];
  var MOTIF = { lock_fam_energia_armonico: 1, lock_fam_estructura_armonico: 1, sol_elem_tierra_tierra: 1 };
  // Asunto propio para dos casas (revisión astrológica L4): la 8 nombra el sexo y la 7 suena a
  // que la carta decide. La frase literal sigue en la tarjeta del email.
  var CASA_ASUNTO = { 7: 'Cae justo en la casa de la pareja', 8: 'Cae donde se mezclan la intimidad y lo compartido' };
  function scoreDisplay(n) {
    var r = Math.round(Math.max(0, Math.min(100, n)) * 10) / 10;
    return (r % 1 === 0) ? String(Math.round(r)) : r.toFixed(1).replace('.', ',');
  }
  function gateFacts(resp, entries) {
    var f = {};
    if (!resp || !resp.scores) return f;
    entries = entries || {};
    var g = Number(resp.scores.general);
    if (isFinite(g)) { f.calc_sin_score = Math.round(g); f.calc_sin_general = global.awLang === 'en' ? scoreDisplay(g).replace(',', '.') : scoreDisplay(g); }
    var vals = [];
    AREAS.forEach(function (a) {
      var v = Number(resp.scores[a[0]]);
      if (isFinite(v)) vals.push({ label: T(a[1]), v: Math.max(0, Math.min(100, Math.round(v))) });
    });
    if (vals.length === AREAS.length) {
      var hi = vals[0], lo = vals[0];
      vals.forEach(function (x) { if (x.v > hi.v) hi = x; if (x.v < lo.v) lo = x; });
      if (hi.v > lo.v) {
        f.calc_sin_alta_area = hi.label; f.calc_sin_alta = String(hi.v);
        f.calc_sin_baja_area = lo.label; f.calc_sin_baja = String(lo.v);
        // Empate (4-5 % de las parejas): el email dice «una de las más bajas», no «la más baja».
        if (vals.filter(function (x) { return x.v === lo.v; }).length > 1) f.calc_sin_baja_empate = T('si');
        if (vals.filter(function (x) { return x.v === hi.v; }).length > 1) f.calc_sin_alta_empate = T('si');
      }
    }
    var arq = entries[archetypeKey(resp)];
    if (arq && arq.nombre) f.calc_sin_dinamica = arq.nombre;
    var readable = pickReadable(resp, function (k) { return !!entries[k]; });
    var locked = pickLocked(resp, readable.map(function (u) { return u.key; })).slice(0, readable.length);
    var motifUsed = false;
    locked.forEach(function (u) {
      var hookE = u.kind === 'aspect' && u.key ? entries[u.key] : null;
      var hookKey = lockHookKey(u);
      var src = (hookE && hookE.titular) ? u.key : ((hookKey && entries[hookKey] && entries[hookKey].titular) ? hookKey : '');
      var hook = src ? entries[src].titular : '';
      if (hook && MOTIF[src]) { if (motifUsed) { hook = ''; } else { motifUsed = true; } }
      if (!hook) return;
      if (u.kind === 'aspect' && !f.calc_sin_candado_tit) {
        f.calc_sin_candado_tit = hook; f.calc_sin_candado_seccion = T(lockSection(u.aspect));
      }
      if (u.kind === 'overlay' && !f.calc_sin_casa_tit) {
        f.calc_sin_casa_tit = hook; f.calc_sin_casa = houseProp(u.house); f.calc_sin_casa_planeta = T(u.planet_es);
        f.calc_sin_casa_asunto = CASA_ASUNTO[u.house] ? T(CASA_ASUNTO[u.house]) : hook;
      }
    });
    var pa = resp.person_a || {}, pb = resp.person_b || {};
    if (pa.sol && pa.sol.sign_es) f.calc_sin_sol_a = T(pa.sol.sign_es);
    if (pb.sol && pb.sol.sign_es) f.calc_sin_sol_b = T(pb.sol.sign_es);
    if (resp.composite && resp.composite.sun_sign_es) f.calc_sin_sol_compuesto = T(resp.composite.sun_sign_es);
    var meta = resp.meta || {};
    if (meta.time_unknown_a || meta.time_unknown_b) f.calc_sin_hora_falta = T('si');
    return f;
  }

  var api = { archetypeKey: archetypeKey, aspectKey: aspectKey, pickReadable: pickReadable, pickLocked: pickLocked, lockSection: lockSection, lockHookKey: lockHookKey, gateFacts: gateFacts, _familia: familia };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; }
  if (typeof global.window !== 'undefined') { global.AWSinSelect = api; }
})(typeof window !== 'undefined' ? window : globalThis);
